module.exports = __webpack_public_path__ + "static/media/plugin-fallback.72c294e6.svg";